import React from "react";
import { Heart, Star, Sparkles } from "lucide-react";
import { CATS } from "../../data/pusheen";

const FLOATERS = [
  { src: CATS.heart, cls: "top-[14%] left-[4%] w-16 sm:w-24 animate-float", delay: "0s" },
  { src: CATS.cookie, cls: "top-[26%] right-[5%] w-16 sm:w-24 animate-bob", delay: "0.6s" },
  { src: CATS.sleep, cls: "top-[62%] left-[3%] w-20 sm:w-28 animate-sway", delay: "0.3s" },
  { src: CATS.donut, cls: "top-[74%] right-[4%] w-16 sm:w-24 animate-float", delay: "1s" },
  { src: CATS.wave, cls: "top-[44%] left-[8%] w-14 sm:w-20 animate-wiggle hidden md:block", delay: "0.2s" },
];

const SPARKS = [
  { Icon: Star, cls: "top-[18%] left-[24%] w-4 text-white", d: "0s" },
  { Icon: Heart, cls: "top-[30%] left-[40%] w-5 text-pusheen-pink fill-pusheen-pink", d: "0.5s" },
  { Icon: Sparkles, cls: "top-[12%] right-[30%] w-6 text-white", d: "1s" },
  { Icon: Star, cls: "top-[58%] right-[26%] w-4 text-white", d: "0.8s" },
  { Icon: Heart, cls: "top-[70%] left-[34%] w-5 text-pusheen-pink fill-pusheen-pink", d: "1.4s" },
  { Icon: Sparkles, cls: "top-[85%] right-[38%] w-5 text-white", d: "0.3s" },
];

export default function FloatingBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      {FLOATERS.map((f, i) => (
        <img
          key={i}
          src={f.src}
          alt=""
          className={`absolute drop-shadow-[3px_4px_0_rgba(74,55,40,0.15)] opacity-70 ${f.cls}`}
          style={{ animationDelay: f.delay }}
        />
      ))}
      {SPARKS.map(({ Icon, cls, d }, i) => (
        <Icon key={`s${i}`} className={`absolute animate-twinkle ${cls}`} style={{ animationDelay: d }} />
      ))}
    </div>
  );
}
